import HeaderRequest from '../lib/common/header-request';
import axios from 'axios';
import CustomUrl from '../lib/common/custom-url'
import {
    ROUTE_INSPECTIONS,
    ROUTE_CUSTOMER,
    ROUTE_INSPECTION_STATE,
    ROUTE_INSPECTION_INFO,
    ROUTE_INSPECTION_PICTURES,
    ROUTE_INSPECTION_POLICY,
    ROUTE_INSPECTION_COMMENTS_DAMAGES,
    ROUTE_INSPECTION_ACCESORIES,
    ROUTE_INSPECTION_PICTURES_DAMAGES,
    ROUTE_INSPECTION_APPROVED,
    ROUTE_INSPECTION_RETURN_TO_APPROVED,
    ROUTE_INSPECTION_RETURN_TO_IN_PERSON,
    ROUTE_INSPECTION_IN_PERSON_TO_CREATE,
    ROUTE_INSPECTION_PICTURES_OBSERVED,
    ROUTE_INSPECTION_RETURN,
    ROUTE_INSPECTION_COMMENTS_GENERAL,
    ROUTE_INSPECTION_DERIVE,
    ROUTE_INSPECTION_REJECTED,
    ROUTE_INSPECTION_PRESENCIAL,
    ROUTE_INSPECTION_REPORT,
    ROUTE_INSPECTION_UPDATE_VEHICLE_PLATE,
    ROUTE_INSPECTION_REMOVE_INSPECTIONS,
    /*Creacion ruta para cambiar estado de inspeccion */
    ROUTE_INSPECTION_IN_PERSON_TO_RETURN
} from '../constants/routes/routes-service';

class InspectionApi {
    constructor(action$, store, deps) {
        this.action$ = action$;
        this.store = store;
        this.deps = deps;
    }

    getAll = (payload) => {
        let url = CustomUrl.getURL(ROUTE_INSPECTIONS, payload);
        url += payload.states ? `&states=${payload.states}&page=${payload.page}&size=${payload.size}&searchFilter=${payload.searchFilter}&searchValue=${payload.searchValue}` : '';
        return this.deps.ajax.get(url, HeaderRequest.getRequestHeader());
    };
    getState = (payload) => {
        const { userIdentity, requestId } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_STATE, { userIdentity, requestId });
        url += payload.states ? `&states=${payload.states}` : '';
        return this.deps.ajax.getJSON(url, HeaderRequest.getRequestHeader());
    };
    getCustomer = (payload) => {
        let url = CustomUrl.getURL(ROUTE_CUSTOMER, { userIdentity: payload.userIdentity });
        url += payload.states ? `&states=${payload.states}` : '';
        return this.deps.ajax.getJSON(url, HeaderRequest.getRequestHeader());
    };
    getInfoInspection = (payload) => {
        const { userIdentity, requestId } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_INFO, { userIdentity, requestId });
        return this.deps.ajax.getJSON(url, HeaderRequest.getRequestHeader());
    };
    getPictures = (payload) => {
        const { userIdentity, requestId } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_PICTURES, { userIdentity, requestId });
        return this.deps.ajax.getJSON(url, HeaderRequest.getRequestHeader());
    };
    getPicturesDamages = (payload) => {
        const { userIdentity, requestId } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_PICTURES_DAMAGES, { userIdentity, requestId });
        return this.deps.ajax.getJSON(url, HeaderRequest.getRequestHeader());
    };
    getPolicy = (payload) => {
        const { policyNumber } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_POLICY, { policyNumber });
        return this.deps.ajax.getJSON(url, HeaderRequest.getRequestHeader());
    };
    saveComment = (payload) => {
        const { userIdentity, requestId, damageComment } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_COMMENTS_DAMAGES, { userIdentity, requestId })
        return this.deps.ajax.patch(url, { damageComment }, HeaderRequest.getRequestHeader());
    };
    saveGeneralComment = (payload) => {
        const { userIdentity, requestId, generalComment } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_COMMENTS_GENERAL, { userIdentity, requestId })
        return this.deps.ajax.patch(url, { generalComment }, HeaderRequest.getRequestHeader());
    };
    getAccesories = (payload) => {
        const { userIdentity, requestId } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_ACCESORIES, { userIdentity, requestId });
        return this.deps.ajax.getJSON(url, HeaderRequest.getRequestHeader());
    };
    approvedInspection = (payload) => {
        const { userIdentity, requestId } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_APPROVED, { userIdentity, requestId });
        return this.deps.ajax.patch(url, {}, HeaderRequest.getRequestHeader());
    };

    returnToApproved = (payload) => {
        const { userIdentity, requestId } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_RETURN_TO_APPROVED, { userIdentity, requestId });
        return this.deps.ajax.patch(url, {}, HeaderRequest.getRequestHeader());
    };

    returnToInPerson = (payload) => {
        const { userIdentity, requestId } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_RETURN_TO_IN_PERSON, { userIdentity, requestId });
        return this.deps.ajax.patch(url, {}, HeaderRequest.getRequestHeader());
    };

    inPersonToCreate = (payload) => {
        const { userIdentity, requestId } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_IN_PERSON_TO_CREATE, { userIdentity, requestId });
        return this.deps.ajax.patch(url, {}, HeaderRequest.getRequestHeader());
    };

     /*Payload De presencial a devuelto*/
     inPersonToReturn = (payload) => {
        const { userIdentity, requestId } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_IN_PERSON_TO_RETURN, { userIdentity, requestId });
        return this.deps.ajax.patch(url, {}, HeaderRequest.getRequestHeader());
    };
   
    

    updateVehiclePlate = (payload) => {
        const { userIdentity, requestId, newVehiclePlate } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_UPDATE_VEHICLE_PLATE, { userIdentity, requestId });
        return this.deps.ajax.patch(`${url}?newVehiclePlate=${newVehiclePlate}`, {}, HeaderRequest.getRequestHeader());
    };

   


    removeInspections = (payload) => {
        let url = CustomUrl.getURL(ROUTE_INSPECTION_REMOVE_INSPECTIONS);
        return this.deps.ajax.put(url, payload, HeaderRequest.getRequestHeader());
    };

    presencialInspection = (payload) => {
        const { userIdentity, requestId, body } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_PRESENCIAL, { userIdentity, requestId });
        return this.deps.ajax.patch(url, body, HeaderRequest.getRequestHeader());
    };
    rejectedInspection = (payload) => {
        const { userIdentity, requestId, reasonCode } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_REJECTED, { userIdentity, requestId });
        return this.deps.ajax.patch(url, { reasonCode }, HeaderRequest.getRequestHeader());
    };
    registerPictureObserved = (payload) => {
        const { userIdentity, requestId, modelReturn } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_PICTURES_OBSERVED, { userIdentity, requestId });
        return this.deps.ajax.post(url, modelReturn, HeaderRequest.getRequestHeader());
    };
    getReport = (payload) => {
        const { date } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_REPORT);
        return this.deps.ajax.post(url, date, HeaderRequest.getRequestHeader());
    };
    returnInspection = (payload) => {
        const { userIdentity, requestId } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_RETURN, { userIdentity, requestId });
        return this.deps.ajax.patch(url, {}, HeaderRequest.getRequestHeader());
    };
    deriveInspection = (payload) => {
        const { userIdentity, requestId, reasonCode } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_DERIVE, { userIdentity, requestId });
        return this.deps.ajax.patch(url, { reasonCode }, HeaderRequest.getRequestHeader());
    };
    loadPicturesObserved = (payload) => {
        const { userIdentity, requestId } = payload;
        let url = CustomUrl.getURL(ROUTE_INSPECTION_PICTURES_OBSERVED, { userIdentity, requestId });
        return this.deps.ajax.getJSON(url, HeaderRequest.getRequestHeader());
    };
    getReportWithUrl = (file) => {
        return axios.get(file, HeaderRequest.getRequestHeader())
            .then(function(response) {
                return response.data
            })
            .catch(function(error) {
                return error;
            });
    }
}

export default InspectionApi;


// WEBPACK FOOTER //
// ./src/api/inspection.js